import React, { PureComponent } from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import { getPage } from "actions/page/page.functions";

import { SEO } from "components";

class Contact extends PureComponent {
  componentDidMount(){
    const { dispatch } = this.props;
    
    let slug = "contact";
    dispatch(getPage(slug));
  }

  render() {
    const { singlePage } = this.props;

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    return (
      <main className="view-contact">
        <SEO {...seoProps} />
        <section className="view-contact__splash">
          <div className="wrapper">
            <div className="view-contact__splash__heading">
              <h1 className="u-type--beta u-type--primary">Get in Touch!</h1>
            </div>
          </div>
        </section>

        <div className="wrapper">
          <form onSubmit={this.handleFormSubmit} className="view-contact__form">
            <div className="field">
              <label className="field__lbl" htmlFor="name">
                Name
              </label>
              <input
                className="input input--med"
                ref="name"
                id="name"
                type="text"
                placeholder="Your name..."
              />
            </div>

            <div className="field">
              <label className="field__lbl" htmlFor="email">
                E-mail
              </label>
              <input
                className="input input--med"
                ref="email"
                id="email"
                type="email"
                placeholder="Your e-mail..."
              />
            </div>

            <div className="field">
              <label className="field__lbl" htmlFor="phone">
                Phone
              </label>
              <input
                className="input input--med"
                ref="phone"
                id="phone"
                type="email"
                placeholder="Your phone number..."
              />
            </div>

            <div className="field">
              <label className="field__lbl" htmlFor="subject">
                Subject
              </label>
              <input
                className="input input--med"
                ref="subject"
                id="subject"
                type="dropdown"
                placeholder="Inquiry"
              />
            </div>

            <div className="field">
              <label className="field__lbl" htmlFor="message">
                Message
              </label>
              <textarea
                className="input input--med input--textarea"
                ref="message"
                id="message"
                type="textarea"
                placeholder="Message"
                row="18"
              />
            </div>

            <button className="contact__action btn btn--med btn--primary u-rounded">
              Send message
            </button>
          </form>
        </div>
      </main>
    );
  }
}


const mapStateToProps = state => {
  const { singlePage } = state.pages;

  return {
    singlePage
  };
};

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/views/Contact.jsx